<template>
    <el-aside width="100%">
        <!-- <el-input  
            placeholder="输入关键字定位"
            v-model="filterText">
        </el-input> -->
        

        <!-- <el-tree
            class="filter-tree"
            :data="tableData"
            :props="{ label: 'name' }"
            default-expand-all
            :filter-node-method="filterNode"
            ref="tree">
        </el-tree> -->

        <el-tree
            :data="tableData"
            :props="{ label: 'deptName' }"
            accordion
            @node-click="handleNodeClick">
        </el-tree>
    </el-aside>
</template>

<script>
    export default {
        name: 'DeptTree',
        data() {
            return {
                tableData: []
            }
        },
		created() {
			this.getDeptTree()
		},watch: {
			filterText(val) {
				this.$refs.tree.filter(val);
			}
		},
        methods: {
            getDeptTree() {
				this.$axios.get("/base/dept/list").then(res => {
					this.tableData = res.data.data
				})
			},
            filterNode(value, data) {
				if (!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			handleNodeClick(data) {
                this.$emit('getTreeData', data);
				// console.log(data);
			}
        }
    } 
</script>

<style scoped >
	
</style>